import React from 'react';
import { TreeDeciduous, RectangleHorizontal, Building2, Lock, Check } from 'lucide-react';
import { services } from '../data/mock';

const iconMap = { TreeDeciduous, RectangleHorizontal, Building2, Lock };

const scrollToDevis = () => {
  const element = document.getElementById('devis');
  if (element) element.scrollIntoView({ behavior: 'smooth' });
};

const Services = () => {
  return (
    <section id="services" className="py-16 md:py-24 bg-white relative overflow-hidden" data-testid="services-section">
      <div className="absolute left-0 top-0 w-1/4 h-full blue-stripes opacity-40 pointer-events-none hidden lg:block"></div>
      <div className="max-w-7xl mx-auto px-4 relative">
        <div className="mb-10 md:mb-16 max-w-3xl">
          <p className="text-[#1F6FD6] font-display font-bold text-xs md:text-sm uppercase tracking-[0.2em] md:tracking-[0.3em] mb-3">Conception · Fabrication · Pose · SAV</p>
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-black text-[#01162D] mb-5 tracking-tight">
            Nos <span className="text-[#1F6FD6]">Services</span>
          </h2>
          <div className="w-20 h-1 bg-[#1F6FD6] mb-6"></div>
          <p className="text-base md:text-lg text-[#647A97]">
            Un savoir-faire complet pour tous vos projets de menuiserie et de serrurerie.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {services.map((service, index) => {
            const IconComponent = iconMap[service.icon];
            return (
              <div
                key={service.id}
                className="group bg-[#EEF1F5] rounded-md p-6 md:p-8 border-t-4 border-[#01162D] hover:border-[#1F6FD6] hover:bg-white hover:shadow-2xl hover:shadow-[#01162D]/10 transition-all duration-500 hover:-translate-y-2"
                data-testid={`service-card-${service.id}`}
              >
                <div className="flex items-center justify-between mb-6">
                  <div className="w-14 h-14 bg-[#01162D] group-hover:bg-[#1F6FD6] rounded-md flex items-center justify-center transition-colors duration-300">
                    <IconComponent size={28} className="text-white" />
                  </div>
                  <span className="font-display text-4xl font-black text-[#01162D]/10 group-hover:text-[#1F6FD6]/20 transition-colors">
                    0{index + 1}
                  </span>
                </div>

                <h3 className="text-xl font-bold text-[#01162D] mb-3 tracking-tight">
                  {service.title}
                </h3>

                <p className="text-[#647A97] mb-6 leading-relaxed text-sm">
                  {service.description}
                </p>

                <ul className="space-y-2">
                  {service.features.map((feature, idx) => (
                    <li key={idx} className="flex items-start gap-2 text-sm text-[#01162D]">
                      <Check size={16} className="text-[#1F6FD6] mt-0.5 flex-shrink-0" />
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>

        <div className="mt-12 md:mt-16 steel-sheen rounded-md p-7 md:p-12 flex flex-col md:flex-row md:items-center md:justify-between gap-8 shadow-2xl">
          <div>
            <h3 className="text-2xl md:text-3xl font-bold text-white mb-2 tracking-tight">Un projet en tête ?</h3>
            <p className="text-[#9FB3CC] text-base md:text-lg max-w-xl">
              Notre équipe vous conseille et réalise vos projets sur mesure, du particulier au chantier professionnel.
            </p>
          </div>
          <button
            onClick={scrollToDevis}
            className="bg-[#1F6FD6] text-white px-9 py-4 rounded-md font-display font-bold uppercase tracking-wider hover:bg-white hover:text-[#01162D] transition-colors duration-300 shadow-xl whitespace-nowrap w-full md:w-auto"
            data-testid="services-cta-devis"
          >
            Demander un devis
          </button>
        </div>
      </div>
    </section>
  );
};

export default Services;
